"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const log_node_1 = require("@video/log-node");
const adapter_1 = require("../../../api/adapter");
const feature_1 = require("../../../api/adapter/features/feature");
const errors_deprecated_1 = require("../../errors-deprecated");
const context_1 = require("../../utils/context/context");
const event_emitter_1 = require("../../utils/events/event-emitter");
const common_1 = require("./common");
const echo_1 = tslib_1.__importDefault(require("./echo"));
const messageList_1 = require("./messageList");
let producerAudioContext = null;
adapter_1.onceDeviceReady.then((dev) => {
    if (dev.isImplements(feature_1.Feature.AUDIO_CONTEXT)) {
        producerAudioContext = new dev.AudioContext();
    }
});
const VIDEO = "video";
const AUDIO = "audio";
class Stream extends event_emitter_1.ObservableEventEmitter {
    constructor(ctx, streamName, call, options_) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super();
        (0, context_1.onceCanceled)(ctx).then((reason) => this.dispose(`Stream Context Cancelled: ${reason}`));
        this.ctx = ctx;
        this.streamName = streamName;
        this.call = call;
        const options = options_ !== null && options_ !== void 0 ? options_ : {};
        // Audio options
        this._audioOptions = (_a = options.audio) !== null && _a !== void 0 ? _a : {};
        if (this._audioOptions.streamProvider != null) {
            this._audioStreamProvider = (_b = this._audioOptions.streamProvider) !== null && _b !== void 0 ? _b : null;
            this._audioStreamProviderType = (_c = this._audioOptions.streamProviderType) !== null && _c !== void 0 ? _c : common_1.CUSTOM_STREAM_TYPE;
        }
        else {
            this._audioStreamProvider = null;
            this._audioStreamProviderType = null;
        }
        this._useEchoDetection = (_d = this._audioOptions.echoDetection) !== null && _d !== void 0 ? _d : false;
        // Video options
        this._videoOptions = (_e = options.video) !== null && _e !== void 0 ? _e : {};
        if (this._videoOptions.streamProvider != null) {
            this._videoStreamProvider = (_f = this._videoOptions.streamProvider) !== null && _f !== void 0 ? _f : null;
            this._videoStreamProviderType = (_g = this._videoOptions.streamProviderType) !== null && _g !== void 0 ? _g : common_1.CUSTOM_STREAM_TYPE;
        }
        else {
            this._videoStreamProvider = null;
            this._videoStreamProviderType = null;
        }
        this._videoProducer = null;
        this._audioProducer = null;
        // if (this._useEchoDetection && producerAudioContext != null) {
        //   this._gainNode = producerAudioContext.createGain();
        //   this._baseGainValue = this._gainNode.gain.value;
        //   this._echoDetector = null;
        // }
        this._statsInterval = (_h = options.statsInterval) !== null && _h !== void 0 ? _h : 5000;
        ctx.logger.attachObject(this);
        ctx.logger.trace("constructor()", this);
        this.addInnerDisposer(() => {
            this.close();
        });
    }
    get logData() {
        return {
            streamName: this.streamName,
        };
    }
    get audioProducer() {
        return this._audioProducer;
    }
    get videoProducer() {
        return this._videoProducer;
    }
    get hasVideoStreamTrack() {
        var _a;
        const source = (_a = this._videoStreamProvider) === null || _a === void 0 ? void 0 : _a.source;
        if (source == null) {
            return false;
        }
        return source.getVideoTracks().length > 0;
    }
    get hasAudioStreamTrack() {
        var _a;
        const source = (_a = this._audioStreamProvider) === null || _a === void 0 ? void 0 : _a.source;
        if (source == null) {
            return false;
        }
        return source.getAudioTracks().length > 0;
    }
    async setVideoStreamProvider(streamProvider, options, execute, preview) {
        return this._setMediaStreamProvider(VIDEO, streamProvider, options, execute, false, preview);
    }
    async setAudioStreamProvider(streamProvider, options, execute, preview) {
        return this._setMediaStreamProvider(AUDIO, streamProvider, options, execute, false, preview);
    }
    checkPermissions(video) {
        if (video && !this.call.hasPermission(common_1.PERMISSIONS.STREAM_VIDEO)) {
            this.throwErrorDeprecated(new errors_deprecated_1.PermissionsError("no permission to stream video", { stream: this, permissions: this.call.permissions }));
        }
        else if (!video && !this.call.hasPermission(common_1.PERMISSIONS.STREAM_AUDIO)) {
            this.throwErrorDeprecated(new errors_deprecated_1.PermissionsError("no permission to stream audio", { stream: this, permissions: this.call.permissions }));
        }
    }
    async _setMediaStreamProvider(kind, streamProvider, options, execute, final, preview) {
        var _a, _b, _c;
        this.ctx.logger.debug("setMediaStreamRetriever", {
            ...this.logData,
            kind,
        });
        const video = kind === VIDEO;
        let producer = null;
        let revertStreamProvider = null;
        let revertStreamProviderType;
        if (video) {
            revertStreamProvider = this._videoStreamProvider;
            revertStreamProviderType = this._videoStreamProviderType;
            this._videoStreamProvider = streamProvider;
            this._videoStreamProviderType = (_a = options.streamType) !== null && _a !== void 0 ? _a : common_1.CUSTOM_STREAM_TYPE;
            producer = this._videoProducer;
        }
        else {
            revertStreamProvider = this._audioStreamProvider;
            revertStreamProviderType = this._audioStreamProviderType;
            this._audioStreamProvider = streamProvider;
            this._audioStreamProviderType = (_b = options.streamType) !== null && _b !== void 0 ? _b : common_1.CUSTOM_STREAM_TYPE;
            producer = this._audioProducer;
        }
        if (!execute) {
            return null;
        }
        this.checkPermissions(video);
        if (producer != null && !producer.closed) {
            if (producer.track != null) {
                producer.track.stop();
            }
            let stream;
            try {
                stream = streamProvider.source;
                if (stream == null) {
                    this.ctx.logger.error("Stream provider returned null", {
                        ...this.logData,
                        kind,
                    });
                    return null;
                }
            }
            catch (err) {
                const msg = err instanceof Error ? err.message : "unknown error";
                this.ctx.logger.warn("Unable to get media stream", {
                    err: msg,
                    ...this.logData,
                    kind,
                });
                if (!final && revertStreamProvider != null) {
                    try {
                        const revertOptions = { ...options, streamType: revertStreamProviderType !== null && revertStreamProviderType !== void 0 ? revertStreamProviderType : common_1.CUSTOM_STREAM_TYPE };
                        await this._setMediaStreamProvider(kind, revertStreamProvider, revertOptions, true, true, false);
                    }
                    catch (error) {
                        this.emitErrorDeprecated(new errors_deprecated_1.InternalError(`Unable to revert media stream: ${kind}`, {}));
                    }
                }
                throw err;
            }
            let track;
            if (video) {
                [track] = stream.getVideoTracks();
            }
            else {
                [track] = stream.getAudioTracks();
            }
            this.ctx.logger.info("replacing producer track", {
                ...this.logData,
                kind,
                trackLabel: track === null || track === void 0 ? void 0 : track.label,
                trackState: track === null || track === void 0 ? void 0 : track.readyState,
                settings: (track === null || track === void 0 ? void 0 : track.getSettings) != null ? track.getSettings() : null,
                capabilities: (track === null || track === void 0 ? void 0 : track.getCapabilities) != null ? track.getCapabilities() : null,
                constraints: (track === null || track === void 0 ? void 0 : track.getConstraints) != null ? track.getConstraints() : null,
            });
            if (track == null) {
                this.ctx.logger.error("stream has no tracks of this kind", {
                    ...this.logData,
                    kind,
                    stream: stream,
                });
                throw new Error("Unable to get track");
            }
            await producer.replaceTrack({ track });
            if (producer.paused) {
                producer.resume();
                this.call._resumeProducer(producer.id, this.streamName);
            }
            this.call.emit("CALL_SET_PRODUCER_TRACK", {
                streamName: this.streamName,
                streamType: (_c = options.streamType) !== null && _c !== void 0 ? _c : common_1.CUSTOM_STREAM_TYPE,
                producerId: producer.id,
                track,
            });
            return producer;
        }
        this.ctx.logger.info("cannot replaceTrack, so resetting producer", {
            ...this.logData,
        });
        try {
            producer = await this._setProducer(kind, options, preview);
        }
        catch (error) {
            this.ctx.logger.warn("unable to set new producer", {
                ...this.logData,
                kind,
            });
        }
        return producer;
    }
    async _setProducer(kind, options, preview = false, hotswap = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const video = kind === VIDEO;
        this.checkPermissions(video);
        let stream;
        try {
            if (video) {
                if (!hotswap && ((_a = this._videoProducer) === null || _a === void 0 ? void 0 : _a.track) != null) {
                    this._videoProducer.track.stop();
                }
                if (this._videoStreamProvider == null) {
                    this.throwErrorDeprecated(new errors_deprecated_1.RetrievingMediaStreamError("videoStreamProvider is not provided", {
                        streamName: this.logData.streamName,
                        mediaKind: kind,
                    }));
                }
                const s = this._videoStreamProvider.source;
                if (s == null) {
                    this.throwErrorDeprecated(new errors_deprecated_1.RetrievingMediaStreamError("videoStreamProvider returned null", {
                        streamName: this.logData.streamName,
                        mediaKind: kind,
                    }));
                }
                stream = s;
                this.ctx.logger.debug("retrieve a new video stream", { stream: stream });
            }
            else {
                if (!hotswap && ((_b = this._audioProducer) === null || _b === void 0 ? void 0 : _b.track) != null) {
                    this._audioProducer.track.stop();
                }
                if (this._audioStreamProvider == null) {
                    this.throwErrorDeprecated(new errors_deprecated_1.RetrievingMediaStreamError("audioStreamProvider is not provided", {
                        streamName: this.logData.streamName,
                        mediaKind: kind,
                    }));
                }
                const s = this._audioStreamProvider.source;
                if (s == null) {
                    this.throwErrorDeprecated(new errors_deprecated_1.RetrievingMediaStreamError("audioStreamProvider returned null", {
                        streamName: this.logData.streamName,
                        mediaKind: kind,
                    }));
                }
                stream = s;
                this.ctx.logger.debug("retrieve a new audio stream", { stream: stream });
            }
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            this.ctx.logger.warn("Unable to get media stream", {
                err: msg,
                ...this.logData,
                kind,
            });
            throw err;
        }
        let switched = false;
        let track;
        let producer;
        if (video) {
            [track] = stream.getVideoTracks();
            const appData = {
                streamName: this.streamName,
                userId: this.call.user.userId,
                trackEnabled: track === null || track === void 0 ? void 0 : track.enabled,
                displayName: this.call.user.displayName,
            };
            if (video) {
                if (adapter_1.device.isImplements(feature_1.Feature.SCREEN_ORIENTATION)) {
                    appData.orientation = adapter_1.device.screenOrientation;
                }
                // if (window.screen?.orientation?.angle != null) {
                //     appData.orientation = window.screen.orientation.angle;
                // } else if (window.orientation != null) {
                //     appData.orientation = window.orientation;
                // }
            }
            if (track == null) {
                const err = new Error("stream.getVideoTracks()[0] is undefined");
                this.ctx.logger.warn("Unable to get media track", {
                    err: err === null || err === void 0 ? void 0 : err.message,
                    ...this.logData,
                    kind,
                });
                throw err;
            }
            // Ios the producer does not close fast enough and here it thinks it exists when it is actually closed.
            if (this._videoProducer && !hotswap && !adapter_1.device.isIosDevice) {
                try {
                    await this._videoProducer.replaceTrack({ track });
                    producer = this._videoProducer;
                    switched = true;
                }
                catch (err) {
                    const msg = err instanceof Error ? err.message : "unknown error";
                    this.ctx.logger.warn("Unable to replace track", {
                        err: msg,
                        ...this.logData,
                        kind,
                    });
                    producer = await this.call.createProducer(track, options, appData);
                }
            }
            else {
                producer = await this.call.createProducer(track, options, appData);
            }
        }
        else {
            const appData = {
                streamName: this.streamName,
                userId: this.call.user.userId,
                displayName: this.call.user.displayName,
            };
            let parallelTrack;
            // send from stream to this._gainNode
            if (this._useEchoDetection &&
                (producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.createMediaStreamSource) != null &&
                (producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.createMediaStreamDestination) != null &&
                this._gainNode != null) {
                const mediaStreamSource = producerAudioContext.createMediaStreamSource(stream);
                mediaStreamSource.connect(this._gainNode);
                // send from this._gainNode to a new destination stream
                const dest = producerAudioContext.createMediaStreamDestination();
                this._gainNode.connect(dest);
                [track] = dest.stream.getAudioTracks();
                [parallelTrack] = stream.getAudioTracks();
            }
            else {
                [track] = stream.getAudioTracks();
            }
            if (track == null) {
                const err = new Error("stream.getAudioTracks()[0] is undefined");
                this.ctx.logger.warn("Unable to get media track", {
                    err: err === null || err === void 0 ? void 0 : err.message,
                    ...this.logData,
                    kind,
                });
                throw err;
            }
            if (this._audioProducer && !hotswap) {
                try {
                    await this._audioProducer.replaceTrack({ track });
                    producer = this._audioProducer;
                    switched = true;
                }
                catch (err) {
                    const msg = err instanceof Error ? err.message : "unknown error";
                    this.ctx.logger.warn("Unable to replace track", {
                        err: msg,
                        ...this.logData,
                        kind,
                    });
                    producer = await this.call.createProducer(track, options, appData);
                    producer.appData.parallelTrack = parallelTrack;
                }
            }
            else {
                producer = await this.call.createProducer(track, options, appData);
                producer.appData.parallelTrack = parallelTrack;
            }
        }
        // No need to keep original track.
        // !!! DISABLED BECAUSE NOW WE DON'T CLONE TRACKS !!!
        // track.stop();
        let oldProducer = null;
        if (video) {
            if (!switched) {
                oldProducer = this._videoProducer;
                this._videoProducer = producer;
            }
        }
        else {
            if (!switched) {
                oldProducer = this._audioProducer;
                this._audioProducer = producer;
            }
            if (this._useEchoDetection) {
                try {
                    this._echoDetector = new echo_1.default(producer.track);
                    (_c = this._echoDetector) === null || _c === void 0 ? void 0 : _c.on("echo", () => {
                        var _a;
                        this.ctx.logger.debug(`echo detected at ${Date.now()}. Gain at ${(_a = this._gainNode) === null || _a === void 0 ? void 0 : _a.gain.value}`, {
                            ...this.logData,
                        });
                        this._reduceGain();
                    });
                    (_d = this._echoDetector) === null || _d === void 0 ? void 0 : _d.on("noecho", () => {
                        var _a;
                        this.ctx.logger.debug(`echo stopped at ${Date.now()}. Gain at ${(_a = this._gainNode) === null || _a === void 0 ? void 0 : _a.gain.value}`, {
                            ...this.logData,
                        });
                        this._restoreGain();
                    });
                }
                catch (err) {
                    const msg = err instanceof Error ? err.message : "unknown error";
                    this.ctx.logger.error("unable to set up echo detector", {
                        err: msg,
                        ...this.logData,
                    });
                }
            }
        }
        const close = (msg) => {
            this.ctx.logger.debug(msg, {
                ...this.logData,
            });
            if (producer.appData.parallelTrack != null) {
                producer.appData.parallelTrack.stop();
            }
            let producerId = "";
            if (video && this._videoProducer != null) {
                producerId = this._videoProducer.id;
                this._videoProducer = null;
            }
            else if (this._audioProducer != null) {
                producerId = this._audioProducer.id;
                this._audioProducer = null;
            }
            this.call._closeProducer(producerId, this.streamName);
        };
        producer === null || producer === void 0 ? void 0 : producer.once("transportclose", () => close("producer transportclose"));
        producer === null || producer === void 0 ? void 0 : producer.once("trackended", () => close("producer trackended"));
        if (!this.call._closed) {
            if (video) {
                this.call._removeMessage(messageList_1.TROUBLESHOOTING.NO_WEBCAM);
                this.call.emit("CALL_ADD_PRODUCER", {
                    streamerName: this.streamName,
                    producer: {
                        id: producer.id,
                        kind: VIDEO,
                        streamName: this.streamName,
                        streamType: (_e = options.streamType) !== null && _e !== void 0 ? _e : common_1.CUSTOM_STREAM_TYPE,
                        paused: producer.paused,
                        track: producer.track,
                        codec: (_h = (_g = (_f = producer.rtpParameters) === null || _f === void 0 ? void 0 : _f.codecs[0]) === null || _g === void 0 ? void 0 : _g.mimeType.split("/")[1]) !== null && _h !== void 0 ? _h : "",
                        preview,
                    },
                });
            }
            else {
                this.call._removeMessage(messageList_1.TROUBLESHOOTING.NO_MIC);
                this.call.emit("CALL_ADD_PRODUCER", {
                    streamerName: this.streamName,
                    producer: {
                        id: producer.id,
                        kind: AUDIO,
                        streamName: this.streamName,
                        streamType: (_j = options.streamType) !== null && _j !== void 0 ? _j : common_1.CUSTOM_STREAM_TYPE,
                        paused: producer.paused,
                        track: producer.track,
                        codec: (_m = (_l = (_k = producer.rtpParameters) === null || _k === void 0 ? void 0 : _k.codecs[0]) === null || _l === void 0 ? void 0 : _l.mimeType.split("/")[1]) !== null && _m !== void 0 ? _m : "",
                        preview,
                    },
                });
            }
            this.ctx.logger.debug("producer set", {
                ...this.logData,
                kind,
                producerId: producer.id,
            });
        }
        if (oldProducer != null && !oldProducer.closed) {
            oldProducer.close();
            this.call._closeProducer(oldProducer.id, this.streamName);
        }
        return producer;
    }
    disableAudio() {
        if (this._audioProducer == null) {
            this.ctx.logger.warn("stream.disableAudio: calling disableAudio without an audio producer", {
                ...this.logData,
            });
            return;
        }
        this.ctx.logger.debug("disableAudio", {
            ...this.logData,
        });
        try {
            this._audioProducer.close();
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            this.ctx.logger.error("unable to close audio producer", {
                err: msg,
                ...this.logData,
            });
            throw err;
        }
        this.call._closeProducer(this._audioProducer.id, this.streamName);
        this._audioProducer = null;
    }
    pauseAudio() {
        if (this._audioProducer == null) {
            this.ctx.logger.warn("stream.pauseAudio: calling pauseAudio without an audio producer", {
                ...this.logData,
            });
            return;
        }
        this.ctx.logger.debug("pauseAudio", {
            ...this.logData,
        });
        this._audioProducer.pause();
        this.call._pauseProducer(this._audioProducer.id, this.streamName);
    }
    async enableAudio(options = {}, refresh = false, preview = false) {
        var _a, _b, _c;
        this.ctx.logger.debug("enableAudio", {
            ...this.logData,
        });
        /* TODO: see enableVideo note
        if (!this.call._room || !this.call._room.joined) {
            log.warn('enableAudio called before the room was joined', {
                ...this.logData,
            });
            return;
        }
        */
        if (this._audioProducer == null || this._audioProducer.closed || refresh) {
            if (this._audioStreamProvider == null) {
                const msg = "no default audio stream retriever";
                this.ctx.logger.error(msg, {
                    ...this.logData,
                });
                throw new Error(msg);
            }
            try {
                const prodOptions = { ...options, streamType: (_a = this._videoStreamProviderType) !== null && _a !== void 0 ? _a : common_1.CUSTOM_STREAM_TYPE };
                await this._setProducer(AUDIO, prodOptions, preview);
            }
            catch (err) {
                const msg = err instanceof Error ? err.message : "unknown error";
                this.ctx.logger.warn("unable to set up audio producer", {
                    err: msg,
                    ...this.logData,
                });
                throw err;
            }
            if (!((_c = (_b = this._audioProducer) === null || _b === void 0 ? void 0 : _b.track) === null || _c === void 0 ? void 0 : _c.enabled)) {
                this.pauseAudio();
            }
            return;
        }
        this._audioProducer.resume();
        this.call._resumeProducer(this._audioProducer.id, this.streamName);
    }
    async enableVideo(options = {}, refresh = false, preview = false) {
        var _a, _b, _c;
        this.ctx.logger.debug("enableVideo", {
            ...this.logData,
            options: options,
            refresh,
            preview,
        });
        /* TODO: come up with a ready indicator
         * - possibley add a lock with a timeout to fix
         *   this race condition possibility
        if (!this.call._room || !this.call._room.joined) {
            log.warn('enableVideo called before the room was joined', {
                ...this.logData,
            });
            return;
        }
        */
        if (this._videoProducer == null || this._videoProducer.closed || refresh) {
            if (this._videoStreamProvider == null) {
                const msg = "no default video stream retriever";
                this.ctx.logger.error(msg, {
                    ...this.logData,
                });
                throw new Error(msg);
            }
            try {
                const prodOptions = { ...options, streamType: (_a = this._videoStreamProviderType) !== null && _a !== void 0 ? _a : common_1.CUSTOM_STREAM_TYPE };
                await this._setProducer(VIDEO, prodOptions, preview);
            }
            catch (err) {
                const msg = err instanceof Error ? err.message : "unknown error";
                this.ctx.logger.warn("unable to set up video producer", {
                    err: msg,
                    ...this.logData,
                });
                throw err;
            }
            if (!((_c = (_b = this._videoProducer) === null || _b === void 0 ? void 0 : _b.track) === null || _c === void 0 ? void 0 : _c.enabled)) {
                this.pauseVideo();
            }
            return;
        }
        this._videoProducer.resume();
        this.call._resumeProducer(this._videoProducer.id, this.streamName);
    }
    disableVideo() {
        if (this._videoProducer == null) {
            this.ctx.logger.warn("stream.disableVideo: calling disable video without a video producer", {
                ...this.logData,
            });
            return;
        }
        this.ctx.logger.debug("disableVideo", {
            ...this.logData,
        });
        try {
            this._videoProducer.close();
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            this.ctx.logger.error("unable to close video producer", {
                err: msg,
                ...this.logData,
            });
            throw err;
        }
        this.call._closeProducer(this._videoProducer.id, this.streamName);
        this._videoProducer = null;
    }
    pauseVideo() {
        if (this._videoProducer == null) {
            this.ctx.logger.warn("stream.pauseVideo: calling pause video without a video producer", {
                ...this.logData,
            });
            return;
        }
        this.ctx.logger.debug("pauseVideo", {
            ...this.logData,
        });
        this._videoProducer.pause();
        this.call._pauseProducer(this._videoProducer.id, this.streamName);
    }
    async hotswapProducer(kind, producerOptions) {
        var _a, _b;
        try {
            if (producerOptions.streamType == null) {
                if (kind === "video") {
                    producerOptions.streamType = (_a = this._videoStreamProviderType) !== null && _a !== void 0 ? _a : common_1.CUSTOM_STREAM_TYPE;
                }
                else {
                    producerOptions.streamType = (_b = this._audioStreamProviderType) !== null && _b !== void 0 ? _b : common_1.CUSTOM_STREAM_TYPE;
                }
            }
            await this._setProducer(VIDEO, producerOptions, false, true);
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            this.ctx.logger.warn("unable to hotswap producer", {
                kind,
                producerOptions,
                err: msg,
                ...this.logData,
            });
            throw err;
        }
    }
    _reduceGain() {
        var _a, _b;
        if (this._gainNode != null) {
            this._gainNode.gain.cancelScheduledValues((_a = producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.currentTime) !== null && _a !== void 0 ? _a : 0);
            this._gainNode.gain.exponentialRampToValueAtTime(0.5, (_b = producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.currentTime) !== null && _b !== void 0 ? _b : 0);
        }
    }
    _restoreGain() {
        var _a, _b;
        if (this._gainNode != null && this._baseGainValue != null) {
            this._gainNode.gain.cancelScheduledValues((_a = producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.currentTime) !== null && _a !== void 0 ? _a : 0);
            this._gainNode.gain.exponentialRampToValueAtTime(this._baseGainValue, ((_b = producerAudioContext === null || producerAudioContext === void 0 ? void 0 : producerAudioContext.currentTime) !== null && _b !== void 0 ? _b : 0) + 30);
        }
    }
    close(sendSfuEvents = true) {
        if (this._audioProducer != null) {
            if (sendSfuEvents) {
                this.call._closeProducer(this._audioProducer.id, this.streamName);
            }
            this._audioProducer.close();
            this._audioProducer = null;
        }
        if (this._videoProducer != null) {
            if (sendSfuEvents) {
                this.call._closeProducer(this._videoProducer.id, this.streamName);
            }
            this._videoProducer.close();
            this._videoProducer = null;
        }
        if (this._echoDetector != null) {
            this._echoDetector.close();
            this._echoDetector = null;
        }
    }
    toJSON() {
        var _a, _b;
        return {
            audioProducer: this.audioProducer == null
                ? null
                : {
                    id: this.audioProducer.id,
                    closed: this.audioProducer.closed,
                    paused: this.audioProducer.paused,
                    trackId: (_a = this.audioProducer.track) === null || _a === void 0 ? void 0 : _a.id,
                },
            videoProducer: this.videoProducer == null
                ? null
                : {
                    id: this.videoProducer.id,
                    closed: this.videoProducer.closed,
                    paused: this.videoProducer.paused,
                    trackId: (_b = this.videoProducer.track) === null || _b === void 0 ? void 0 : _b.id,
                },
            aggregates: {
                support: this.ctx.support.hash,
                ...(0, log_node_1.extractAggregates)(this.call),
                streamName: this.streamName,
            },
        };
    }
}
Stream.displayName = "PvcStream";
exports.default = Stream;
//# sourceMappingURL=stream.js.map